let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
if (!flag) {
  window.location.href = 'http://www.bjseln.com/'
}


// WEBPACK FOOTER //
// ./src/util/isMobile.js